import request from '../../../helpers/request';

const createRoomImages = async (descriptionId, files = []) => {
  await Promise.all(
    files.map(async (file) => {
      const formData = new FormData();
      formData.append('file', file);
      return request.post(
        `/RentPlace/description/${descriptionId}/attachment`,
        formData,
        'При загрузке изображения произошла ошибка'
      );
    })
  );
};

export default createRoomImages;
